angular.module('app').controller('app.controller', [
    'config',
    '$scope',
    '$localStorage',
    '$state',
    '$window',
    '$rootScope',
    '$location',
    '$uibModal',
    '$timeout',
    'ui',
    '$http',
    'app.purchase.purchaseFlowService',
    function (
        config,
        $scope,
        $localStorage,
        $state,
        $window,
        $rootScope,
        $location,
        $uibModal,
        $timeout,
        ui,
        $http,
        purchaseFlowService
    ) {
        var timeInterval = environment.statusInterval;
        if (!timeInterval) {
            timeInterval = 1000;// default
        }

        var timer = $timeout(function timerComplete() {
            $http.get(environment.statusUrl + 'online/status/' + environment.portalId).then(function (response) {
                if (response.status != 200) {
                    //navigate to offline                    
                    $state.go('app.offline');
                } else {
                    //check for banner message
                    purchaseFlowService.checkStatusMessages()
                        .then(function (result) {
                            if (result.length > 0) {
                                //display toaster message   
                                var m = result[0];
                                const message = {
                                    messageType: m.messageType,
                                    severity: m.severity,
                                    title: m.title,
                                    description: m.description,
                                    hyperlink: m.hyperlink
                                };
                                ui.systemMessage(message);
                                timer = $timeout(timerComplete, timeInterval);
                            }
                        })
                        .catch(function rejected(result) {
                            ui.handleError(rejected);
                        })
                        .finally(function () {
                            ui.unblock();
                        });
                }
            }).catch(function rejected(result) {
                //navigate to offline       
                if (result.status == 503) {
                    $state.go('app.offline');
                } else {
                    ui.handleError(rejected);
                }

            }).finally(function () {
                ui.unblock();
            });
        }, timeInterval);

        siteContent.hideLocationModal = false;
        siteContent.hideCCPAModal = false;
        siteContent.ignoreStateVerification = false;
        siteContent.landingPath = 'app.landing';
        siteContent.findDentistPage = '/#/find-a-dentist';
        siteContent.joinPage = '/#/plans';
        siteContent.supportPage = '/#/support';

        $scope.siteContent = siteContent;

        $window.document.title = siteContent.plan;

        $scope.app = config;
        $scope.$state = $state;
        $scope.$rootScope = $rootScope;
        $scope.environment = environment;
        $scope.$location = $location;
        $scope.date = new Date().getFullYear();
        $scope.memberPortalUrl = environment.memberPortalUrl;
        $scope.cdiCustomerSupportNumber = environment.cdiCustomerSupportNumber;
        $scope.msdpLogoUrl = environment.blobStorageTopUrl + '/site-graphics/msdp/logo.svg';
        $scope.localState = '';

        $scope.launchInvite = launchInvite;

        if (angular.isDefined($localStorage.state)) {
            $scope.app.state = $localStorage.state;
        } else {
            $localStorage.state = $scope.app.state;
        }

        config.settings.apiKey = environment.apiKey;
        config.settings.memberPortalUrl = environment.memberPortalUrl;
        config.settings.instrumentationKey = environment.instrumentationKey;

        storePromoCodeUrlParam();
        listenForClickAnywhereElseEvents();

        $scope.$watch(
            function () {
                return location.hash;
            },
            function (value) {
                if (digitalData[0].transaction.id == null) {
                    var pageID = $location.path();
                    var newData = [
                        {
                            'page': {
                                'pageInfo': {
                                    'pageID': pageID
                                }
                            },
                            'transaction': {
                                'id': null
                            },
                            'attributes': {
                                'promoCode': null
                            }
                        }
                    ];

                    digitalData = Object.assign({}, newData);
                }
            }
        );

        /* PROMOTION CODE STORAGE AND RETRIEVAL */
        function storePromoCodeUrlParam() {
            // Check for previous code
            promoCode = parseLocalStoragePromoCode();
            // Check if previous code has expired
            if (promoCode) {
                expireLocalStorage();
            }
            // Get URL parameters
            var pCode;
            var queryString = window.location.search.slice(1);
            if (queryString) {
                var params = queryString.split('&');
                for (var i = 0; i < params.length; i++) {
                    var pair = params[i].split('=');
                    // Grab value for Pcode param
                    if (pair[0] == 'Pcode') {
                        pCode = pair[1];
                    }
                }
                // If this is a new promo code
                if (pCode != promoCode) {
                    // Store the new code in local storage along with timestamp
                    var object = { value: pCode, timestamp: new Date().getTime() };
                    localStorage.setItem('promoCode', JSON.stringify(object));
                }
            }
        }

        function parseLocalStoragePromoCode() {
            // Return promo code from local storage
            var object = JSON.parse(localStorage.getItem('promoCode'));
            if (object) {
                promoCode = object.value;
                return promoCode;
            }
        }

        function expireLocalStorage() {
            // Grab timestamp value from local storage
            var object = JSON.parse(localStorage.getItem('promoCode'));
            if (object) {
                dateString = object.timestamp;
                // Get today's timestamp
                now = new Date().getTime().toString();
                // Convert timestamp into hours
                elapsedTime = Math.ceil((now - dateString) / 3600000);
                // Set expiration time in hours
                expiration = 360; // 15 days
                // If timestamp is past expiration then delete
                if (elapsedTime >= expiration) {
                    localStorage.removeItem('promoCode');
                }
            }
        }

        function listenForClickAnywhereElseEvents() {
            angular.element(document).on('click', function (event) {
                //If the user clicks on anything OTHER than the #wrapper-notifications element or notification icon
                if (
                    !$(event.target).closest(angular.element(document).find('#mobile-menu-icon')).length &&
                    !$(event.target).closest(angular.element(document).find('#wrapper-app-mobile-menu')).length
                ) {
                    $scope.collapsed = true;
                    //Ensure the Angular model updates properly (i.e. perform the scope life cycle)
                    $scope.$apply();
                }
            });
        }

        $.ajaxSetup({
            beforeSend: function (xhr) {
                xhr.setRequestHeader('Ocp-Apim-Subscription-Key', config.settings.apiKey);
            },
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        });

        function launchInvite() {
            $uibModal
                .open({
                    templateUrl: '/app/site/purchase-flow/invite-to-plan/invite-to-plan.html',
                    controller: 'app.purchase.InviteToPlanController',
                    controllerAs: 'vm'
                })
                .result.then(function fulfilled(result) {
                    if (result === true) {
                        $uibModal.open({
                            templateUrl: '/app/site/purchase-flow/invite-to-plan/invite-success.html',
                            controller: 'app.purchase.InviteToPlanResponseController',
                            controllerAs: 'vm'
                        });
                    } else {
                        $uibModal.open({
                            templateUrl: '/app/site/purchase-flow/invite-to-plan/invite-failure.html',
                            controller: 'app.purchase.InviteToPlanResponseController',
                            controllerAs: 'vm'
                        });
                    }
                });
        }
    }
]);
